import Dialog from 'components/dialog/Base'
import { useCallback, useState } from 'react'

import type { ProvidedProps } from 'hooks/useDocUpload'

export type DialogStatus = 'close' | 'confirm' | 'success' | 'failed'

interface Props {
  state: DialogStatus
  setStatus: (s: DialogStatus) => void
  onSend: ProvidedProps['onSendMobile']
  confirmAPILimit: ProvidedProps['confirmAPILimit']
  reset: () => void
}

const TITLES = {
  confirm: 'アップロードしてOCRします',
  success: 'アップロードが完了しました',
  failed: 'アップロードが失敗しました',
}

const CONFIRM_MSG =
  'アップロードを実行すると選択したファイルがOCR処理されてLINE WORKS OCR Readerに結果データが保存されます'
const FAILED_MSG = (
  <>
    画像のアップロードに失敗しました。
    <br />
    サイズや形式が対応されているか確認のうえ、
    <br />
    再度時間をおいてからお試しください。
    <br />
  </>
)

const UploadDialog = ({ state, setStatus, onSend, reset, confirmAPILimit }: Props) => {
  const [sending, setSending] = useState(false)
  const title = TITLES[state]
  const handleConfirm = useCallback(async () => {
    setSending(true)
    const result = await onSend()
    if (result === 'trialApiLimit') {
      setStatus('close')
      confirmAPILimit()
    } else {
      result === 'failed' ? setStatus('failed') : setStatus('success')
    }
    setSending(false)
    reset()
  }, [onSend, reset, setStatus, confirmAPILimit])

  const handleClose = useCallback(() => {
    setStatus('close')
  }, [setStatus])

  return (
    <Dialog
      open={state !== 'close'}
      title={title}
      headerAlign="center"
      loading={sending}
      cancelText="キャンセル"
      actionText={state === 'confirm' ? 'アップロード' : '閉じる'}
      onAction={state === 'confirm' ? handleConfirm : handleClose}
      onCancel={state === 'confirm' ? handleClose : undefined}
    >
      {state === 'failed' ? FAILED_MSG : CONFIRM_MSG}
    </Dialog>
  )
}

export default UploadDialog
